import { fabric } from "fabric";

export class FabricExtensions {
  public static extendFabric() {
    this.addCustomControlIcons();
    this.addArrowClass();
    this.addCustomControls();
  }

  public static createOverwrittenITextClass(
    textInput: string,
    optionInput: any
  ): fabric.IText {
    var text = fabric.util.createClass(fabric.IText, {
      _renderBackground: function (ctx) {
        if (!this.backgroundColor) return;

        var dim = this._getNonTransformedDimensions();
        ctx.fillStyle = this.backgroundColor;
        let x = dim.x + this.padding / this.scaleX;
        let y = dim.y + this.padding / this.scaleY;
        ctx.fillRect(-x / 2, -y / 2, x, y);
        // if there is background color no other shadows
        // should be casted
        this._removeShadow(ctx);
      },
      render: function (ctx) {
        this.clearContextTop();
        this.callSuper("render", ctx);
        this.cursorOffsetCache = {};
        this.renderCursorOrSelection();

        ctx.strokeStyle = this.cornerColor;
        ctx.lineWidth = 4; // this could also be an extra param on textbox
        let coords = this._getCoords();
        ctx.beginPath();
        ctx.moveTo(coords.tl.x, coords.tl.y);
        ctx.lineTo(coords.tr.x, coords.tr.y);
        ctx.lineTo(coords.br.x, coords.br.y);
        ctx.lineTo(coords.bl.x, coords.bl.y);
        ctx.closePath();
        ctx.stroke();
      },
      /**
       * @private
       * @param {CanvasRenderingContext2D} ctx Context to render on
       */
      _render: function (ctx) {
        this.callSuper("_render", ctx);
      },
    });
    text.prototype.set({
      _getNonTransformedDimensions() {
        // Object dimensions
        return new fabric.Point(this.width, this.height).scalarAdd(
          this.padding
        );
      },

      _calculateCurrentDimensions() {
        // Controls dimensions
        return fabric.util.transformPoint(
          this._getTransformedDimensions(),
          this.getViewportTransform(),
          true
        );
      },
    });
    return new text(textInput, optionInput);
  }

  private static addArrowClass(): void {
    // Extended fabric line class
    fabric["LineArrow"] = fabric.util.createClass(fabric.Line, {
      type: "lineArrow",

      initialize: function (element, options) {
        options ||
          (options = {
            originX: "center",
            originY: "center",
          });
        this.callSuper("initialize", element, options);
      },

      toObject: function () {
        return fabric.util.object.clone(this.callSuper("toObject"));
      },

      calcPoints: function () {
        let p = this.calcLinePoints();
        let pointZero = new fabric.Point(0, 0);
        let center = this.getCenterPoint();
        let point1 = fabric.util.rotatePoint(
          new fabric.Point(p.x1, p.y1),
          pointZero,
          fabric.util.degreesToRadians(this.angle)
        );
        let point2 = fabric.util.rotatePoint(
          new fabric.Point(p.x2, p.y2),
          pointZero,
          fabric.util.degreesToRadians(this.angle)
        );
        return {
          x1: point1.x + center.x,
          x2: point2.x + center.x,
          y1: point1.y + center.y,
          y2: point2.y + center.y,
        };
      },
      calcPointsWithoutRotate: function () {
        let p = this.calcLinePoints();
        let center = this.getCenterPoint();
        return {
          x1: p.x1 + center.x,
          y1: p.y1 + center.y,
          x2: p.x2 + center.x,
          y2: p.y2 + center.y,
        };
      },

      _render: function (ctx) {
        this.callSuper("_render", ctx);
        let p = this.calcLinePoints();
        //arrow start point
        if (this.arrowType == 1 || this.arrowType == 3) {
          let xDiff = -this.x2 + this.x1;
          let yDiff = -this.y2 + this.y1;
          let angle = Math.atan2(yDiff, xDiff);
          this.drawArrow(angle, p.x1, p.y1, ctx);
        }
        //arrow end right
        if (this.arrowType == 2 || this.arrowType == 3) {
          let xDiff = this.x2 - this.x1;
          let yDiff = this.y2 - this.y1;
          let angle = Math.atan2(yDiff, xDiff);
          this.drawArrow(angle, p.x2, p.y2, ctx);
        }

        ctx.restore();
      },

      drawArrow: function (angle, xPos, yPos, ctx) {
        ctx.save();
        ctx.translate(xPos, yPos);
        ctx.rotate(angle);
        ctx.beginPath();
        // Move 5px in front of line to start the arrow so it does not have the square line end showing in front (0,0)
        let sqrt = Math.sqrt(this.strokeWidth);
        let offset = (this.strokeWidth * 4) / sqrt;
        let coord = (this.strokeWidth * 5) / sqrt;
        ctx.moveTo(offset, 0);
        ctx.lineTo(-coord, coord);
        ctx.lineTo(-coord, -coord);
        ctx.closePath();
        ctx.fillStyle = this.stroke;
        ctx.fill();
        ctx.restore();
      },
    });
    let touchEventCache = {};
    fabric["LineArrow"].prototype.controls.mlArrow = new fabric.Control({
      x: -0.5,
      y: 0,
      // cursorStyleHandler: scaleSkewStyleHandler,
      mouseDownHandler: function (
        _event: MouseEvent | TouchEvent,
        transform,
        _x,
        _y
      ) {
        // if (_event.defaultPrevented) return false;
        // transform.target.setControlVisible("mlArrow", false);
        transform.target.transparentCorners = true;
        touchEventCache = {};
        if (_event instanceof TouchEvent)
          for (let i = 0; i < _event.touches.length; i++) {
            let touch = _event.touches.item(i);
            touchEventCache[touch.identifier] = touch;
          }

        return true;
      },
      mouseUpHandler: function (_event, transform, _x, _y) {
        // if (_event.defaultPrevented) return false;
        // transform.target.setControlVisible("mlArrow", true);
        transform.target.transparentCorners = false;
        return true;
      },
      actionHandler: function (
        eventData: MouseEvent | TouchEvent,
        transform,
        _x,
        _y
      ) {
        var target = transform.target as any;
        var movementX: number = 0;
        var movementY: number = 0;
        if (eventData instanceof MouseEvent) {
          movementX = eventData.movementX;
          movementY = eventData.movementY;
        } else if (eventData instanceof TouchEvent) {
          let touch = eventData.changedTouches.item(0);
          let cached = touchEventCache[touch.identifier];
          if (touch && cached) {
            movementX = touch.clientX - cached.clientX;
            movementY = touch.clientY - cached.clientY;
            touchEventCache[touch.identifier] = touch;
          }
        }
        var points = target.calcPoints();
        if (points.x1 + movementX < 0) movementX = -points.x1;
        else if (points.x1 + movementX > target.canvas.width)
          movementX = target.canvas.width - points.x1;
        if (points.y1 + movementY < 0) movementY = -points.y1;
        else if (points.y1 + movementY > target.canvas.height)
          movementY = target.canvas.height - points.y1;
        var len = Math.sqrt(
          Math.pow(points.x2 - points.x1 - movementX, 2) +
            Math.pow(points.y2 - points.y1 - movementY, 2)
        );
        var targetCenter = target.getCenterPoint();
        var angle =
          (fabric.util.radiansToDegrees(
            Math.atan2(
              points.y1 - targetCenter.y + movementY / 2,
              points.x1 - targetCenter.x + movementX / 2
            )
          ) +
            180) %
          360;
        var absoluteP2 = new fabric.Point(points.x2, points.y2);
        var radians = fabric.util.degreesToRadians(angle - 180);
        var center = new fabric.Point(
          absoluteP2.x + (len * Math.cos(radians)) / 2,
          absoluteP2.y + (len * Math.sin(radians)) / 2
        );
        var p2 = fabric.util.rotatePoint(
          absoluteP2,
          center,
          fabric.util.degreesToRadians(360 - angle)
        );
        var p1 = new fabric.Point(p2.x - len, p2.y);
        target.set({
          x1: p1.x,
          y1: p1.y,
          x2: p2.x,
          y2: p2.y,
          angle,
          left: center.x,
          top: center.y,
        });
        return true;
      },
      actionName: "mlArrow",
    });
    fabric["LineArrow"].prototype.controls.mrArrow = new fabric.Control({
      x: 0.5,
      y: 0,
      // cursorStyleHandler: scaleSkewStyleHandler,
      mouseDownHandler: function (
        _event: MouseEvent | TouchEvent,
        transform,
        _x,
        _y
      ) {
        // if (_event.defaultPrevented) return false;
        // transform.target.setControlVisible("mrArrow", false);
        transform.target.transparentCorners = true;
        touchEventCache = {};
        if (_event instanceof TouchEvent)
          for (let i = 0; i < _event.touches.length; i++) {
            let touch = _event.touches.item(i);
            touchEventCache[touch.identifier] = touch;
          }
        return true;
      },
      mouseUpHandler: function (_event, transform, _x, _y) {
        // if (_event.defaultPrevented) return false;
        // transform.target.setControlVisible("mrArrow", true);
        transform.target.transparentCorners = false;
        return true;
      },
      actionHandler: function (
        eventData: MouseEvent | TouchEvent,
        transform,
        _x,
        _y
      ) {
        var target = transform.target as any;
        var movementX: number = 0;
        var movementY: number = 0;
        if (eventData instanceof MouseEvent) {
          movementX = eventData.movementX;
          movementY = eventData.movementY;
        } else if (eventData instanceof TouchEvent) {
          let touch = eventData.changedTouches.item(0);
          let cached = touchEventCache[touch.identifier];
          if (touch && cached) {
            movementX = touch.clientX - cached.clientX;
            movementY = touch.clientY - cached.clientY;
            touchEventCache[touch.identifier] = touch;
          }
        }
        var points = target.calcPoints();
        if (points.x2 + movementX < 0) movementX = -points.x2;
        else if (points.x2 + movementX > target.canvas.width)
          movementX = target.canvas.width - points.x2;
        if (points.y2 + movementY < 0) movementY = -points.y2;
        else if (points.y2 + movementY > target.canvas.height)
          movementY = target.canvas.height - points.y2;
        var len = Math.sqrt(
          Math.pow(points.x2 - points.x1 + movementX, 2) +
            Math.pow(points.y2 - points.y1 + movementY, 2)
        );
        var targetCenter = target.getCenterPoint();
        var angle =
          fabric.util.radiansToDegrees(
            Math.atan2(
              points.y2 - targetCenter.y + movementY / 2,
              points.x2 - targetCenter.x + movementX / 2
            )
          ) % 360;
        var absoluteP1 = new fabric.Point(points.x1, points.y1);
        var radians = fabric.util.degreesToRadians(angle);
        var center = new fabric.Point(
          absoluteP1.x + (len * Math.cos(radians)) / 2,
          absoluteP1.y + (len * Math.sin(radians)) / 2
        );
        var p1 = fabric.util.rotatePoint(
          absoluteP1,
          center,
          fabric.util.degreesToRadians(360 - angle)
        );
        var p2 = new fabric.Point(p1.x + len, p1.y);
        target.set({
          x1: p1.x,
          y1: p1.y,
          x2: p2.x,
          y2: p2.y,
          angle,
          left: center.x,
          top: center.y,
        });
        return true;
      },
      actionName: "mrArrow",
    });

    fabric["LineArrow"].prototype["customizeCornerIcons"]({
      mlArrow: {
        icon: "assets/open_with_black.svg",
      },
      mrArrow: {
        icon: "assets/open_with_black.svg",
      },
    });

    fabric["LineArrow"].fromObject = function (object, callback) {
      callback &&
        callback(
          new fabric["LineArrow"](
            [object.x1, object.y1, object.x2, object.y2],
            object
          )
        );
    };

    fabric["LineArrow"].async = true;
  }

  private static addCustomControlIcons(): void {
    const renderIcon = function (
      ctx: CanvasRenderingContext2D,
      left: number,
      top: number,
      styleOverride: any,
      fabricObject: fabric.Object
    ) {
      var size = this.cornerSize;
      ctx.save();
      ctx.translate(left, top);
      ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));
      ctx.globalAlpha = fabricObject.transparentCorners ? 0.2 : 1;
      ctx.drawImage(this.icon, -size / 2, -size / 2, size, size);
      ctx.restore();
    };
    fabric.util.object.extend(fabric.Object.prototype, {
      customizeCornerIcons: function (options: {
        [key: string]: { icon: string };
      }) {
        Object.keys(options).forEach((k) => {
          let control = this.controls[k];
          if (control) {
            control.icon = new Image();
            control.icon.src = options[k].icon;
            control.render = renderIcon;
            control.cornerSize = 40;
          }
        });
      },
    });
    fabric.Object.prototype.controls.mtr.offsetY = -10;
  }

  private static findNearest(
    p: fabric.Point,
    a: fabric.Point,
    b: fabric.Point
  ) {
    var atob = { x: b.x - a.x, y: b.y - a.y };
    var atop = { x: p.x - a.x, y: p.y - a.y };
    var len = atob.x * atob.x + atob.y * atob.y;
    var dot = atop.x * atob.x + atop.y * atob.y;
    var t = Math.min(1, Math.max(0, dot / len));
    dot = (b.x - a.x) * (p.y - a.y) - (b.y - a.y) * (p.x - a.x);
    return new fabric.Point(a.x + atob.x * t, a.y + atob.y * t);
  }

  private static addCustomControls() {
    var findNearest = this.findNearest;
    var checkRadiusChange = (
      canvas: fabric.Canvas,
      center: fabric.Point,
      radius: number,
      change: number
    ) => {
      var left = center.x - radius;
      var right = center.x + radius;
      var top = center.y - radius;
      var bottom = center.y + radius;
      if (
        left - change <= 0 ||
        right + change > canvas.width ||
        top - change <= 0 ||
        bottom + change > canvas.height
      )
        return 0;
      else return change;
    };
    let touchEventCache = {};
    fabric.Circle.prototype.controls.tlRadius = new fabric.Control({
      x: -0.35,
      y: -0.35,
      // cursorStyleHandler: scaleSkewStyleHandler,
      mouseDownHandler: function (
        _event: MouseEvent | TouchEvent,
        transform,
        _x,
        _y
      ) {
        transform.target.transparentCorners = true;
        touchEventCache = {};
        if (_event instanceof TouchEvent)
          for (let i = 0; i < _event.touches.length; i++) {
            let touch = _event.touches.item(i);
            touchEventCache[touch.identifier] = touch;
          }
        return true;
      },
      mouseUpHandler: function (
        _event: MouseEvent | TouchEvent,
        transform,
        _x,
        _y
      ) {
        transform.target.transparentCorners = false;
        return true;
      },
      actionHandler: function (
        eventData: MouseEvent | TouchEvent,
        transform,
        _x,
        _y
      ) {
        var movementX: number = 0;
        var movementY: number = 0;
        if (eventData instanceof MouseEvent) {
          movementX = eventData.movementX;
          movementY = eventData.movementY;
        } else if (eventData instanceof TouchEvent) {
          let touch = eventData.changedTouches.item(0);
          let cached = touchEventCache[touch.identifier];
          if (touch && cached) {
            movementX = touch.clientX - cached.clientX;
            movementY = touch.clientY - cached.clientY;
            touchEventCache[touch.identifier] = touch;
          }
        }
        var target = transform.target as fabric.Circle;
        var targetCenter = target.getCenterPoint();
        var center = new fabric.Point(0, 0);
        var tl = target.aCoords.tl.subtract(targetCenter);
        var point = findNearest(
          new fabric.Point(movementX, movementY),
          center.subtract(tl),
          tl
        );
        var angle =
          (fabric.util.radiansToDegrees(Math.atan2(point.y, point.x)) + 180) %
          360;
        var positive = (angle + target.angle) % 360 > 180;
        var radians = fabric.util.degreesToRadians(target.angle % 180);
        var dist =
          (positive ? 1 : -1) *
          Math.sqrt(Math.pow(point.x, 2) + Math.pow(point.y, 2)) *
          (-Math.cos(radians) + Math.sin(radians));
        dist = checkRadiusChange(
          target.canvas,
          targetCenter,
          target.radius,
          dist
        );
        if (target.radius + dist < 5) return false;
        target.set("radius", target.radius + dist);
        return true;
      },
      actionName: "tlRadius",
    });
    fabric.Circle.prototype.controls.brRadius = new fabric.Control({
      x: 0.35,
      y: 0.35,
      // cursorStyleHandler: scaleSkewStyleHandler,
      mouseDownHandler: function (
        _event: MouseEvent | TouchEvent,
        transform,
        _x,
        _y
      ) {
        transform.target.transparentCorners = true;
        touchEventCache = {};
        if (_event instanceof TouchEvent)
          for (let i = 0; i < _event.touches.length; i++) {
            let touch = _event.touches.item(i);
            touchEventCache[touch.identifier] = touch;
          }
        return true;
      },
      mouseUpHandler: function (
        _event: MouseEvent | TouchEvent,
        transform,
        _x,
        _y
      ) {
        transform.target.transparentCorners = false;
        return true;
      },
      actionHandler: function (
        eventData: MouseEvent | TouchEvent,
        transform,
        _x,
        _y
      ) {
        var movementX: number = 0;
        var movementY: number = 0;
        if (eventData instanceof MouseEvent) {
          movementX = eventData.movementX;
          movementY = eventData.movementY;
        } else if (eventData instanceof TouchEvent) {
          let touch = eventData.changedTouches.item(0);
          let cached = touchEventCache[touch.identifier];
          if (touch && cached) {
            movementX = touch.clientX - cached.clientX;
            movementY = touch.clientY - cached.clientY;
            touchEventCache[touch.identifier] = touch;
          }
        }
        var target = transform.target as fabric.Circle;
        var targetCenter = target.getCenterPoint();
        var center = new fabric.Point(0, 0);
        var tl = target.aCoords.tl.subtract(targetCenter);
        var point = findNearest(
          new fabric.Point(movementX, movementY),
          center.subtract(tl),
          tl
        );
        var angle =
          (fabric.util.radiansToDegrees(Math.atan2(point.y, point.x)) + 180) %
          360;
        var positive = (angle + target.angle) % 360 < 180;
        var radians = fabric.util.degreesToRadians(target.angle % 180);
        var dist =
          (positive ? 1 : -1) *
          Math.sqrt(Math.pow(point.x, 2) + Math.pow(point.y, 2)) *
          (-Math.cos(radians) + Math.sin(radians));
        dist = checkRadiusChange(
          target.canvas,
          targetCenter,
          target.radius,
          dist
        );
        if (target.radius + dist < 5) return false;
        target.set("radius", target.radius + dist);
        return true;
      },
      actionName: "brRadius",
    });
    fabric.Circle.prototype["customizeCornerIcons"]({
      tlRadius: {
        icon: "assets/expand_right_left_24dp.svg",
      },
      brRadius: {
        icon: "assets/expand_right_left_24dp.svg",
      },
    });
  }
}
